import { gql, TypedDocumentNode } from "@apollo/client";

import {
  AddFeedbackToCustomizationMutation,
  AddFeedbackToCustomizationMutationVariables,
} from "./AddFeedbackToCustomization.generated";

const ADD_FEEDBACK_TO_CUSTOMIZATION: TypedDocumentNode<
  AddFeedbackToCustomizationMutation,
  AddFeedbackToCustomizationMutationVariables
> = gql`
  mutation AddFeedbackToCustomization(
    $addFeedbackInput: AddFeedbackInput!
  ) {
    addFeedbackToCustomization(addFeedbackInput: $addFeedbackInput) {
      ok
    }
  }
`;

export default ADD_FEEDBACK_TO_CUSTOMIZATION;
